import {Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Results} from '../core/results';
import {Application} from '../applications/application/application';
import {ApplicationsService} from '../applications/applications.service';
import {ApplicationEvent} from '../applications/application/application.event';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import * as _ from 'lodash';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import {Appeal} from './appeal/appeal';
import {LoanComponent} from '../loans/loan/loan.component';
import {
  DisabilityChangeRequestComponent
} from '../disability-change-requests/disability-change-request/disability-change-request.component';
import {Attachment} from '../core/models';
import { ReInstateWithdrawComponent } from './re-instate-withdraw/re-instate-withdraw.component';
import { DisbursementExclusions } from '../applications/application/disbursement.exclusions';
import { AcceptOfferComponent } from './accept-offer/accept-offer/accept-offer.component';
import { SharedServiceService } from './accept-offer/shared-service.service';
import { RejectReason } from '../admin-config/reject-reasons/reject-reason/reject-reason';
import {ApplicationType} from '../applications/application/application-type';
declare var bootbox: any;
declare var $: any;
@Pipe ({
  name : 'test'
})
export class ApplicationPipe implements PipeTransform {
  transform(args : Array<Application>) : any{

  }
}
@Component({
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss']
})
export class ApplicationsComponent implements OnInit {
  appeal: boolean;
  appealData: Appeal;
  track: boolean;
  trackApeal: boolean;
  reopenWithdrawnApeal: boolean;
  withdraw: boolean;
  reInstateWithdraw: boolean;
  withdrawAppeal: boolean;
  requestAppealReProcess: boolean;
  applications: Results<Application> = new Results<Application>();
  application: Application = new Application();
  applicationEvents = new Array<ApplicationEvent>();
  apps = true;
  selectedOption: string;
  termsAccepted: boolean;

  @BlockUI() blockUI: NgBlockUI;

  constructor(private shareService: SharedServiceService,public activeModal: NgbActiveModal, private matSnackBar: MatSnackBar, private applicationServices: ApplicationsService,
              protected gaService: GoogleAnalyticsService,public modalService: NgbModal) {
  }

  search() {
    this.blockUI.start();
    this.applicationServices.search(1, 10, 'DESC', 'createDate', '').subscribe((applications: Results<Application>) => {
      this.applications = applications;
      this.blockUI.stop();
      this.applications.content.forEach((app: Application) => {
        this.application = app;
      });
      this.updateCanReInstate();
    }, (error: HttpErrorResponse) => {

      this.blockUI.stop();
      this.gaService.exception(error.error?.message, true);
      this.matSnackBar.open(error.error.message, 'Okay', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    });
  }

  ngOnInit() {

    this.search();
  }

  openAppeal(application: Application) {
    this.application = application;
    this.appeal = true;
    this.track = false;
    this.apps = false;
    this.trackApeal = false;
    this.withdrawAppeal = false;
    this.withdraw = false;
    this.reopenWithdrawnApeal = false;
    this.requestAppealReProcess = false;
  }

  evaluateBursaryOfferButtonVisibility(application: Application): boolean {
    if(application.fundingBucket === 'BURSARY' &&
      application.acceptLoanOffer === true
      && application.status === 'Rejected'
    && application.acceptLoanOffer === true
    && application?.hideFundingOutCome !== true) {
      return true;
    }
    return false;
  }

  evaluateLoanOfferButtonVisibility(application: Application): boolean {
    if(application.fundingBucket === 'LOAN' && application.acceptBursaryOffer === true && (application.status === 'PendingAcceptanceOfBursaryOffer' || application.status === 'LoanInProgress') ) {
      return true;
    }
    return false;
  }

  updateCanReInstate() {
    this.applications.content.forEach(application => {
      if (application.status === 'Withdrawn') {
        const cycle = application.applicationCycle;
        if (cycle) {
          const termName = cycle.term?.name;
          const isCycle1 = cycle.processCycle === 1 || termName === 'Annual' || termName === 'Year' || termName === 'Semester 1' || termName === 'Trimester 1' || termName === 'OQ Annual 1';
          const isCycle2Or3OrOQ2 = cycle.processCycle === 2 || cycle.processCycle === 3 || termName === 'OQ Annual 2';

          const hasBlockingApplication = this.applications?.content?.some(app => {
            if (app.id === application.id || app.status === 'NotStarted' || app.status === 'Withdrawn' || app.applicationType === ApplicationType.Automated.toString()) {
              return false;
            }

            // Blocking: I cant have 2 applications in the same year
            if (app.year === application.year) {
              const appCycle = app.applicationCycle;
              const appTermName = appCycle?.term?.name;
              const appIsCycle1 = appCycle?.processCycle === 1 || appTermName === 'Annual' || appTermName === 'Year' || appTermName === 'Semester 1' || appTermName === 'Trimester 1' || appTermName === 'OQ Annual 1';
              const appIsCycle2Or3OrOQ2 = appCycle?.processCycle === 2 || appCycle?.processCycle === 3 || appTermName === 'OQ Annual 2';

              // Cycle 1 blocks any other Cycle 1 in the same year
              if (isCycle1 && appIsCycle1) {
                return true;
              }

              // Cycle 2/3/OQ2 blocks same term in the same year
              if (isCycle2Or3OrOQ2 && appIsCycle2Or3OrOQ2 && app.studyTerm?.id === application.studyTerm?.id) {
                return true;
              }

              // Also block if it's the exact same cycle ID
              if (app.applicationCycle?.id === application.applicationCycle?.id) {
                return true;
              }
            }

            return false;
          });

          if (hasBlockingApplication) {
            application.canReInstate = false;
          } else {
            application.canReInstate = true;
          }
        }
      }
    });
  }



  openReInstateWitdrwa(application: Application){
     const modalRef = this.modalService.open(ReInstateWithdrawComponent, {fullscreen: true, modalDialogClass: 'animate-bottom'});
    modalRef.componentInstance.application = application;
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }

  openOfferConfirmation(application: Application){
     const modalRef = this.modalService.open(AcceptOfferComponent, {fullscreen: true, modalDialogClass: 'animate-bottom'});
    modalRef.componentInstance.application = application;
    this.shareService.sendData(application);
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }

  applyForLoan(application: Application) {
    const modalRef = this.modalService.open(LoanComponent, {fullscreen: true, modalDialogClass: 'animate-bottom'});
    modalRef.componentInstance.application = application;
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }

  disabilityChangeRequest(application: Application) {

    const modalRef = this.modalService.open(DisabilityChangeRequestComponent, {fullscreen: true, modalDialogClass: 'animate-bottom'});
    modalRef.componentInstance.application = application;
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }

  openTrackAppeal(application: Application) {
    this.application = application;
    this.trackApeal = true;
    this.appeal = false;
    this.track = false;
    this.apps = false;
    this.withdraw = false;
    this.withdrawAppeal = false;
    this.reopenWithdrawnApeal = false;
    this.requestAppealReProcess = false;
  }

  getStatus(application: Application) {

    // if(application.reference.startsWith('MCS') || application.user.studentType==='Continuing' || application.applicationType==='Hybrid') {
    //     return 'Submitted';
    // }else if(application.isImmediatelyFunded===true  || (application.sassaFunded===true && application.studentType==='FTEN')) {
    //   return 'Provisionally Funded';
    // }
    if (application.status === 'NotStarted') {
      return '';
    } 
    else if((application.status == 'ProvisionallyFunded' || application.status == 'Rejected' || application.status == 'ApplicationProgress') && application?.hideFundingOutCome === true){
      return 'Application in progress';
    }
    else if(application.status ==='ProvisionallyFunded') {
      return 'Funding Eligible for ' + application?.fundingBucket;
    }else if(application.status == 'RegistrationReceived'){
      return 'Registration Received for '+ application?.fundingBucket;
    }else if(application.status ==='Withdrawn') {
      return 'Cancelled';
    }else if(application.status ==='Filtering' || application.status ==='Validation') {
      return 'Filtering and validation';
    }else if(application.status ==='AwaitingEvaluation') {
      return 'Verification';
    }else if(application.status ==='ApplicationInProgress') {
      return 'Requesting Financial AND/OR Academic data';
    }
    if(application.status == 'FundingEligibleForLoan'){
      return 'Funding Eligible Subject to Qualification Check and Document Completion at Institution';
    }
    if(application.status == 'PendingAcceptanceOfBursaryOffer'){
      return 'Pending Acceptance of Bursary Offer';
    }
    return _.startCase(application.status);
  }

  openTrack(application: Application) {

    this.application = application;

    this.applicationServices.getApplicationDetails(application.id).subscribe((applicationEvents: Array<ApplicationEvent>) => {
      this.applicationEvents = applicationEvents;
    });
    this.appeal = false;
    this.trackApeal = false;
    this.track = true;
    this.apps = false;
    this.withdraw = false;
    this.withdrawAppeal = false;
    this.requestAppealReProcess = false;
  }

  openApps() {
    this.trackApeal = false;
    this.appeal = false;
    this.track = false;
    this.apps = true;
    this.withdraw = false;
    this.withdrawAppeal = false;
    this.reopenWithdrawnApeal = false;
    this.requestAppealReProcess = false;
  }

  openWithdraw() {
    this.trackApeal = false;
    this.appeal = false;
    this.track = false;
    this.apps = false;
    this.withdraw = true;
    this.withdrawAppeal = false;
    this.reopenWithdrawnApeal = false;
    this.requestAppealReProcess = false;
  }

  openWithdrawAppeal($event) {

    this.appealData = $event;
    this.trackApeal = false;
    this.appeal = false;
    this.track = false;
    this.apps = false;
    this.withdraw = false;
    this.withdrawAppeal = true;
    this.reopenWithdrawnApeal = false;
    this.requestAppealReProcess = false;
  }

  openReOpenWithdrawnAppeal($event) {
    this.appealData = $event;
    this.trackApeal = false;
    this.appeal = false;
    this.track = false;
    this.apps = false;
    this.withdraw = false;
    this.withdrawAppeal = false;
    this.reopenWithdrawnApeal = true;
    this.requestAppealReProcess = false;
  }

  requestAppealReprocess($event) {
    this.appealData = $event;
    this.trackApeal = false;
    this.appeal = false;
    this.track = false;
    this.apps = false;
    this.withdraw = false;
    this.withdrawAppeal = false;
    this.reopenWithdrawnApeal = false;
    this.requestAppealReProcess = true;
  }


  dismissModal() {
    $('#reasonModal').modal('hide');
    $('#confirm').modal('hide');
  }


  confirmSelection() {

    $('#reasonModal').modal('hide');
    $('#confirm').modal('show');
  }

  openReason(application: Application) {
    this.application = application;
    $('#reasonModal').modal('show');
  }

  isDisability() {
    return this.application?.subFunder?.name?.toLowerCase().indexOf('disability') > -1;
  }

  confirmAcknowledgment() {

    if ((this.application?.disabilityAnnexure?.file instanceof Blob)) {
      this.applicationServices.upload(this.application.disabilityAnnexure.file).subscribe((attachment: Attachment)=>{
        if(attachment) {
          this.application.disabilityAnnexure = attachment;
          this.updated();
        }
      })
    } else {
      this.updated();
    }

  }

  updated() {

    this.blockUI.start();
    this.applicationServices.updateFunder(this.application).subscribe((applicatiom: Application)=>{
      this.blockUI.stop();
      $('#reasonModal').modal('hide');
      $('#confirm').modal('hide');
      this.search();
    }, (error: HttpErrorResponse) => {
      this.blockUI.stop();
      this.gaService.exception(error.error?.message, true);
      if (error.status === 401) {
        this.activeModal.close();
        this.matSnackBar.open('Your session has expired', 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      } else {
        this.matSnackBar.open(error.error.message, 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    });
    $('#reasonModal').modal('hide');
    $('#confirm').modal('hide');

  }
}
